module.exports = __webpack_public_path__ + "static/sogood-530c2ff56dfad4f2ee0b6cd1fedf19de.png";